import setCurrentPage from "src/Utils/setCurrentPage";

const CHARACTERS_AI3S = [
  {
    title: "Cybersecurity\nteam",
    subtitle: "",
    items: [
      "Consistently auditing and\nassessing potential risks",
      "Protecting Generative AI \nmodels from malicious \nattacks",
    ],
    image: "characters/character_1.png",
    next: {
      label: "AI ASSISTED DEMO",
      onClick: () => {
        setCurrentPage(306);
      },
      endIcon: "play",
    },
  },
];

const DATA_CHARACTERS = {
  headerRightText: "BEING AI-FIRST",
  headerLeftImage: "topaz.png",
  title: "Challenges solved",
  bgImage: "RESPONSIBLE_AI/AI3S_d1_05.png",
  characters: CHARACTERS_AI3S,
  back: {
    label: "BACK",
    onClick: () => setCurrentPage(304),
    type: "transparent" as "transparent",
    startIcon: "arrow-left",
  },
  actions: [
    {
      label: "AIS3 Demo",
      onClick: () => {
        setCurrentPage(306);
      },
      endIcon: "play",
    },
  ],
};

export default DATA_CHARACTERS;
